import { Box, Alert } from '@mui/material';

import { CircularProgress, ContainerColumnLeft, Page } from '@occc-app/design-system';

import { useScanDataPastSubmission } from './scan-data-past-submission.container';
import { ScanDataPastSubmissionTable } from './components/scan-data-past-submission-table';
import { Overview } from './scan-data-past-submission-overview-section';

export const ScanDataPastSubmissionPage = () => {
  const { submissionData, pageTitle, pageSubtitle, loading, error } = useScanDataPastSubmission();

  if (loading && !submissionData) {
    return (
      <Page
        browserTabTitle='Past Submission View'
        pageHeaderProps={{
          title: 'Past Submission View',
          subtitle: 'Loading...',
        }}
        containerProps={{ variant: 'md' }}
      >
        <Box display='flex' justifyContent='center' alignItems='center' p={4}>
          <CircularProgress />
        </Box>
      </Page>
    );
  }

  if (error) {
    return (
      <Page
        browserTabTitle='Past Submission View'
        pageHeaderProps={{
          title: 'Past Submission View',
          subtitle: 'Error',
        }}
        containerProps={{ variant: 'md' }}
      >
        <Box p={4}>
          <Alert severity='error'>Failed to load submission details. Please try again.</Alert>
        </Box>
      </Page>
    );
  }

  if (!submissionData) {
    return (
      <Page
        browserTabTitle='Past Submission View'
        pageHeaderProps={{
          title: 'Past Submission View',
          subtitle: 'Not Found',
        }}
        containerProps={{ variant: 'md' }}
      >
        <Box p={4}>
          <Alert severity='warning'>Submission not found.</Alert>
        </Box>
      </Page>
    );
  }

  return (
    <Page
      browserTabTitle={pageTitle}
      pageHeaderProps={{
        title: pageTitle,
        subtitle: pageSubtitle,
      }}
      containerProps={{ variant: 'md' }}
    >
      <ContainerColumnLeft>
        <Overview
          pageTitle={pageTitle}
          pageSubtitle={pageSubtitle}
          submissionData={submissionData}
        />

        <ScanDataPastSubmissionTable
          data={submissionData.submissions}
          submissionDate={submissionData.weekEndingDate}
        />
      </ContainerColumnLeft>
    </Page>
  );
};
